import React, {useEffect, useState} from 'react';
import {Button, Modal} from 'antd';


const Preview = ({handleSubmit, data, loading, handleCheckValidate, showModalStatus, setShowModal}) => {

    const [open, setOpen] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    useEffect(() => {
        setOpen(showModalStatus)
    }, [showModalStatus]);
    useEffect(() => {
        setSubmitLoading(loading)
    }, [loading]);


    const handleCancel = () => {
        setOpen(false);
        setShowModal(false);
    };
    return (
        <>

            <Button className='defBtn blueBtn' type="primary" onClick={() => {
                handleCheckValidate()
            }}>
                پیش نمایش
            </Button>
            <Modal
                open={open}
                title="پیش نمایش"

                onCancel={handleCancel}
                footer={null}
            >


                {data?.productLine?.label &&
                    <div className="keyValue mb-7 mt-7">
                        <div className="key">خط تولید:</div>
                        <div className="value">{data?.productLine?.label}</div>
                    </div>
                }
                {data?.branchId?.label &&
                    <div className="keyValue mb-7 mt-7">
                        <div className="key">واحد:</div>
                        <div className="value">{data?.branchId?.label}</div>
                    </div>
                }

                {data?.product?.label &&
                    <div className="keyValue mb-7">
                        <div className="key">کالا:</div>
                        <div className="value">{data?.product?.label}</div>
                    </div>
                }

                {data &&
                    <div className="keyValue mb-7">
                        <div className="key">تاریخ تولید:</div>
                        <div className="value">{data.dateOfManufacture}</div>
                    </div>
                }


                {data?.seriCreatedBy?.label &&
                    <div className="keyValue mb-7">
                        <div className="key">سرپرست تولید:</div>
                        <div className="value">{data?.seriCreatedBy?.label}</div>
                    </div>
                }


                {data?.numberPerPallet &&
                    <div className="keyValue mb-7">
                        <div className="key">تعداد در پالت :</div>
                        <div className="value">{data?.numberPerPallet}</div>
                    </div>
                }

                {data?.requiredNumber &&
                    <div className="keyValue mb-7">
                        <div className="key">تعداد چاپ :</div>
                        <div className="value">{data?.requiredNumber}</div>
                    </div>
                }


                {data?.description &&
                    <div className="keyValue mb-7">
                        <div className="key">توضیحات :</div>
                        <div className="value">{data?.description}</div>
                    </div>
                }


                <div className='gap-2 flex justify-end items-center'>
                    <Button key="back" className='defBtn redBtn ' onClick={handleCancel}>
                        انصراف
                    </Button>
                    <Button loading={submitLoading} className='defBtn blueBtn' onClick={handleSubmit}>
                        ثبت
                    </Button>
                </div>
            </Modal>
        </>
    );
};
export default Preview;

